import(/* webpackMode: "eager" */ "/vercel/path0/src/app/products/[category]/page.tsx")